/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Muscle_UnknownInputs */

const en_us2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That muscle is not in the catalogue.`)
};

const pt_br2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse músculo não está no catálogo.`)
};

const es_419_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese músculo no está en el catálogo.`)
};

const pt_pt2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse músculo não está no catálogo.`)
};

const fr_fr2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce muscle n'est pas dans le catalogue.`)
};

const de_de2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Muskel ist nicht im Katalog.`)
};

const it_it2_quick_workout_muscle_unknown = /** @type {(inputs: Quick_Workout_Muscle_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo muscolo non è nel catalogo.`)
};

/**
* | output |
* | --- |
* | "That muscle is not in the catalogue." |
*
* @param {Quick_Workout_Muscle_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_muscle_unknown = /** @type {((inputs?: Quick_Workout_Muscle_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Muscle_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_muscle_unknown(inputs)
	if (locale === "es-419") return es_419_quick_workout_muscle_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_muscle_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_muscle_unknown(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_muscle_unknown(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_muscle_unknown(inputs)
	return en_us2_quick_workout_muscle_unknown(inputs)
});
export { quick_workout_muscle_unknown as "quick-workout.muscle_unknown" }